module.exports = __webpack_public_path__ + "img/6.cc189a2c.jpg";